import { useTranslation } from "react-i18next";
import * as Yup from "yup";

import { CaseCreationType } from "src/types";

export function useCaseCreateSchema() {
  const { t } = useTranslation();

  return Yup.object().shape({
    name: Yup.string().required(t("label.isRequiredValidation", { field: t("label.name") })),
    description: Yup.string(),
    caseType: Yup.string().oneOf(
      [CaseCreationType.NORMAL, CaseCreationType.PREDEFINED],
      t("label.oneOfValidation", {
        field: t("label.caseType"),
        options: [CaseCreationType.NORMAL, CaseCreationType.PREDEFINED],
      })
    ),
    userSrid: Yup.string().required(t("label.isRequiredValidation", { field: t("label.srid") })),
  });
}
